<template>
  <div>
    <div class="bodyWrap">
      <!-- 固定返回 -->
      <div class="fixedBox">
        <ul>
          <li class="fixedHigh">
            <img src="../../assets/img/show/qq.png" alt="">
            <p class="text">QQ客</p>
          </li>
          <li>
            <img src="../../assets/img/show/kf.png" alt="">
            <p class="text">0898-6696136</p>
          </li>
          <li @click="scrollTop()">
            <img src="../../assets/img/show/back.png" alt="">
            <p class="text">返回顶部</p>
          </li>
        </ul>
      </div>
      <!-- end -->
      <header>
        <div class="headTop">
          <div class="topBox">
            <div class="headLeft fl">
              <span>时间：2021年3月31日</span>
              <span>星期三</span>
            </div>
            <div class="headRig fr">
              <router-link :to="{name:'show-login'}" tag="span">登录</router-link>
              <router-link to="/register" tag="span">注册</router-link>
            </div>
          </div>
        </div>
        <div class="headBottom">
          <div class="bottomBox">
            <div class="botLeft fl">
              <img src="../../assets/img/show/logo.png" alt="">
            </div>
            <div class="botdRig fr">
              <ul class="fl headUl">
                <li>资源管理</li>
                <li>统计分析</li>
                <li>返回信息网</li>
              </ul>
              <div class="fr headSearch">
                <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="banner2">
        <img src="../../assets/img/show/banner2.png" alt="">
        <div class="bannerBox rigBox">
          <div class="rigBox1 box1">
            <div class="selectBox">
              <el-select v-model="region" placeholder="全部">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </div>
            <div class="searchBox">
              <el-input v-model="input" placeholder="请输入您要检索的数据资源"></el-input>
            </div>
            <div class="searchBtn">
              <button @click="doSearch">立即检索</button>
            </div>
            <span>高级检索</span>
          </div>
          <div class="box2">
            <p>
              热词：<span>可可</span><span>巴戟天</span><span>橡胶</span><span>南药</span><span>番石榴</span><span>荔枝</span><span>蝴蝶兰</span><span>澳洲坚果</span><span>椰子</span><span>水稻</span>
            </p>
          </div>
          <div class="box3">
            <ul>
              <li>
                <img src="../../assets/img/show/himg1.png" alt="">
                <p>资源分类</p>
              </li>
              <li>
                <img src="../../assets/img/show/hoimg2.png" alt="">
                <p>资源统计</p>
              </li>
              <li>
                <img src="../../assets/img/show/hoimg3.png" alt="">
                <p>资源专题</p>
              </li>
              <li>
                <img src="../../assets/img/show/hoimg4.png" alt="">
                <p>种质圃（库）</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="tabZujian">
          <div class="pageBox2">
            <div class="homeTitle">
              <img src="../../assets/img/show/xwzx.png" alt="">
            </div>
            <div class="news">
              <div class="newsLeft">
                <div class="banner">
                  <!-- 轮播图 -->
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <img src="../../assets/img/show/banner3.png" alt="">
                      <div class="textAbsolute">
                        <p>国家橡胶树种质资源圃开展“种质资源科普开放日”活动</p>
                      </div>
                    </div>
                  </div>
                  <div class="imgAbsolute">
                    <img src="../../assets/img/show/bg.png" alt="">
                  </div>
                </div>

              </div>
              <div class="newsRig fr">
                <ul>
                  <li @click="item=0" :class="{green:item==0}">
                    <div class="liLeft">
                      <strong>24</strong>
                      <span>2020-12</span>
                    </div>
                    <div class="border"></div>
                    <div class="liRig">
                      <h1>“三区人才”小分队到东方开展技术服务</h1>
                      <p> 12月18日，由木薯中心、种质资源中心和花卉中心的三区人才专家组成一支“精准扶贫”小分队前往东方开展技术服务工作。</p>
                    </div>
                  </li>
                  <li @click="item=1" :class="{green:item==1}">
                    <div class="liLeft">
                      <strong>24</strong>
                      <span>2020-12</span>
                    </div>
                    <div class="border"></div>
                    <div class="liRig">
                      <h1>“三区人才”小分队到东方开展技术服务</h1>
                      <p> 12月18日，由木薯中心、种质资源中心和花卉中心的三区人才专家组成一支“精准扶贫”小分队前往东方开展技术服务工作。</p>
                    </div>
                  </li>
                  <li @click="item=2" :class="{green:item==2}">
                    <div class="liLeft">
                      <strong>24</strong>
                      <span>2020-12</span>
                    </div>
                    <div class="border"></div>
                    <div class="liRig">
                      <h1>“三区人才”小分队到东方开展技术服务</h1>
                      <p> 12月18日，由木薯中心、种质资源中心和花卉中心的三区人才专家组成一支“精准扶贫”小分队前往东方开展技术服务工作。</p>
                    </div>
                  </li>
                  <li @click="item=3" :class="{green:item==3}">
                    <div class="liLeft">
                      <strong>24</strong>
                      <span>2020-12</span>
                    </div>
                    <div class="border"></div>
                    <div class="liRig">
                      <h1>“三区人才”小分队到东方开展技术服务</h1>
                      <p> 12月18日，由木薯中心、种质资源中心和花卉中心的三区人才专家组成一支“精准扶贫”小分队前往东方开展技术服务工作。</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="more">
            <p>查看更多</p>
          </div>
          <div class="pageBox3">
            <div class="imgRig">
              <img src="../../assets/img/show/bj2.png" alt="">
            </div>
            <div class="imgBottom">
              <img src="../../assets/img/show/bj3.png" alt="">
            </div>
            <div class="pageBox3Div">
              <div class="homeTitle">
                <img src="../../assets/img/show/tszy.png" alt="">
              </div>
              <div class="pageBox">
                <div class="contentLeft">
                  <div class="left1">
                    <h2>资源分类</h2>
                    <ul>
                      <li>产胶作物 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带果树 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li class="liHigh">热带牧草
                        <img src="../../assets/img/show/bjt.png" alt="" class="img">
                        <div class="ulTwo">
                          <p>鲁梅克斯</p>
                          <p>小冠花</p>
                          <p>红豆草</p>
                          <p>甜象草</p>
                          <p>苏丹草</p>
                          <p>高丹草</p>
                          <p>紫花苜蓿</p>
                          <p>皇竹草</p>
                          <p>串叶松香</p>
                          <p>杂交狼尾草</p>
                        </div>
                      </li>
                      <li>热带粮食作物 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带药用植物 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带油料作物 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带香辛饮料植物 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带花卉 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带纤维植物 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                      <li>热带特种蔬菜 <img src="../../assets/img/show/bjt.png" alt="" class="img"></li>
                    </ul>
                  </div>
                  <div class="left2">
                    <h2>
                      <span @click="cur=0" :class="{phHigh:cur==0}">收藏排行</span>
                      <span @click="cur=1" :class="{phHigh:cur==1}">申请排行</span>
                    </h2>
                    <div class="tab-content">
                      <div v-show="cur==0">
                        <ul>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                        </ul>
                      </div>
                      <div v-show="cur==1">
                        <ul>
                          <li>热研7-4566666</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                          <li>热研7-45</li>
                          <li>热研11-23-65</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rigBox fr">
                  <div class="rigBox2">
                    <h2>最新资源<span>查看更多</span></h2>
                    <ul class="perUl">
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">
                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">
                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                      <li>
                        <div class="perFirst">
                          <strong>RO/JP/3 22/52s</strong>
                        </div>
                        <div class="perLast">

                          <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                        </div>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
      </footer>
    </div>
  </div>
</template>
<script>
//全局样式
// import 'src/components/swiper.min.js'
// import "src/style/swiper.min.css";

export default {
  name: "index",
  data() {
    return {
      input: '',
      region: '',
      cur: 0, //默认选中第一个tab
      item: 0,
    };
  },
  mounted() {
    // this.lunbo();
  },
  methods: {
    doSearch(){
      this.$router.push({
        name:'zzp-list'
      })
    },
    scrollTop() {
      //返回顶部效果
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    lunbo() {
      //轮播
      new Swiper(".swiper-container", {
        // slidesPerView: 1.05,
        spaceBetween: 10
      });
      setTimeout(() => {
        new Swiper(".swiper-container", {
          loop: true,
          speed: 2000,
          spaceBetween: 10,
          loop: true,
          autoplay: 5000,
        });
      }, 3000);

    }
  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";

.bodyWrap {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  position: relative;
}

.left1 ul li:hover .ulTwo {
  display: block;

}

.left1 ul li:hover .img {
  display: block !important;
}

.left1 ul li:hover {
  background: #027248 !important;
  color: #fff !important;
}

.fixedBox ul li:hover .text {
  color: #fff !important;
}

.fixedBox ul li:hover {
  background: #1b935c !important;
  cursor: pointer;
}

.fixedBox {
  position: fixed;
  top: 38%;
  bottom: 0;
  right: 125px;
  background: #fff;
  text-align: center;
  width: 92px;
  z-index: 9;
  border-radius: 8px;
  height: 240px;
  opacity: 0.9;

  box-shadow: -2px 22px 19px #eeeeee;
}

.fixedBox ul li {
  height: 70px;
  padding: 10px 0 0 0;
  border-bottom: 1px solid #f7f7f7;
}

.fixedBox ul li:last-child {
  border-bottom: 0 !important;
}

.fixedBox ul li:last-child img {
  margin-top: 12px;
}

.fixedBox ul li:nth-of-type(2) img {
  margin-top: 4px;
}

.fixedHigh {
  background: #1b935c !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.fixedHigh p {
  color: #fff !important;
}

.fixedBox ul li img {
  display: block;
  margin: 0 auto;
}

.fixedBox ul li p {
  font-size: 12px;
  color: #404040;
  margin-top: 7px;
}

.pageBox2 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.pageBox3 {
  position: relative;
}

.pageBox3Div {
  width: 1200px;
  margin: 0 auto;
}

.imgRig {
  position: absolute;
  right: 0;
  top: -47px;
}

.more p {
  font-size: 15px;
  border-top-left-radius: 12px;
  width: 170px;
  height: 36px;
  border: 1px solid #cce7db;
  margin: 38px auto 0 auto;
  color: #02874a;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}

.newsLeft {
  display: inline-block;
}

.newsRig {
  width: 575px;
  display: inline-block;
}

.newsRig ul li {
  padding: 18px 13px 20px 13px;
  cursor: pointer;
}

.green {
  background: #02874a !important;
}

.border {
  width: 1px;
  height: 50px;
  background: #999999;
  display: inline-block;
}

.green strong, .green span, .green p, .green h1 {
  color: #fff !important;
}

.liLeft {
  display: inline-block;
  /* border-right: 1px solid #999999; */

  text-align: center;
  padding-right: 16px;
}

.liLeft strong {
  font-size: 36px;
  color: #999999;
  font-weight: normal;
}

.liLeft span {
  font-size: 15px;
  display: block;
  margin-top: 0px;
  color: #999999;
  text-align: center;
}

.liRig {
  display: inline-block;
  width: 450px;
  float: right;
}

.liRig h1 {
  font-size: 16px;
  color: #333333;
  font-weight: normal;
}

.liRig p {
  margin-top: 9px;
  font-size: 13px;
  text-indent: 30px;
  color: #858585;
  line-height: 20px;
}

.news {
  margin-top: 35px;
  margin-left: -14px;
}

.pageBox {
  margin-top: 45px;
  height: 965px;
}

.imgAbsolute {
  position: absolute;
  left: -340px;
  top: 29px;
  z-index: 1;
}

.textAbsolute {
  width: 535px;
  height: 46px;
  position: absolute;
  left: 15px;
  bottom: -15px;
  z-index: 3;
  padding: 0 20px;
  line-height: 46px;
  background: rgba(0, 0, 0, 0.4);
}

.textAbsolute p {
  font-size: 15px;
  color: #fff;

}

.banner {
  border: 1px solid #027248;
  width: 575px;
  height: 390px;
  border-top-left-radius: 72px;
  position: relative;
}

.banner > img {
  display: block;
  width: 575px;
  height: 390px;
  margin: 14px 0 0 14px;
  position: absolute;
  z-index: 2;
}

.homeTitle img {
  text-align: center;
  margin: 80px auto 0 auto;
  display: block;
}

.banner2 {
  position: relative;
}

.box3 {
  margin-top: 34px;
}

.box3 ul li {
  text-align: center;
  margin: 0 auto;
  display: inline-block;
  width: 25%;
  float: left;
  cursor: pointer;
}

.box1 > span {
  font-size: 15px;
  color: #fff;
  display: inline-block;
  line-height: 50px;
  float: right;
  cursor: pointer;
}

.box3 ul li img {
  display: block;
  width: 93px;

  margin: 0 auto;
}

.box3 ul li p {
  font-size: 15px;
  color: #fff;
  margin-top: -5px;
}

.box2 p {
  font-size: 14px;
  color: #fff;
  margin-top: 13px;
  text-align: left;
}

.box2 p span {
  margin-right: 12px;
}

.bannerBox {
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  width: 880px;
}

.banner2 img {
  display: block;
  width: 100%;
  position: relative;
}

.pageNew {
  margin: 8px auto 0 auto;
  text-align: center;
  padding-bottom: 30px;
}

.pageIndex {
  display: inline-block;
  padding: 2px 0;
  vertical-align: bottom;
}

.pageIndex span {
  font-size: 13px;
  color: #606266;
}

.pageIndex input {
  width: 40px;
  border: 1px solid #dddee1;
  text-align: center;
  font-size: 13px;
  height: 26px;
  line-height: 26px;
  border-radius: 3px;
}

.rigBox2 > h2 {
  font-size: 26px;
  color: #117a53;
  margin: 0 0 10px 0;
  border-bottom: 2px solid #027248;
  font-weight: normal;
}

.rigBox2 > h2 span {
  color: #02874a;
  font-size: 15px;
  float: right;
  margin-top: 13px;
}

.myZy {
  border-radius: 5px;
  background: #fff;
  margin-top: 26px;
}

.perUl li:nth-child(odd) {
  background: #e5f3ed;
}

.myZy span {
  width: 5px;
  height: 26px;
  background: #fff;
  display: inline-block;
  margin-top: 13.5px;
  float: left;
  margin-right: 25px;
}

.myZy li {
  font-size: 16px;
  color: #333333;
  border-bottom: 1px solid #02874a;
  height: 53px;
  line-height: 53px;
}

.myZy li:last-child {
  border-bottom: 0;
}

.myZyHigh {
  background: #02874a;
  color: #fff !important;
}

.yidu {
  color: #02874a !important;
}

.high {
  background: #e5f3ed;
  border-bottom: 1px solid #e5f3ed;
}

.delete {
  display: inline-block;
  margin-right: 27px;
  text-align: right;
  float: right;
}

.delete img {
  width: 23px;
  display: block;
}

.boxUl li {
  padding: 34px 18px;

}

.perUl li {
  padding: 20px 18px;
  cursor: pointer;

}

.line {
  border-bottom: 1px solid #80c3a4;
  margin: 0 18px;
  border-left: 1px solid #c8dcdb;
}

.divFirst p {
  font-size: 15px;
  display: inline-block;
  color: #333333;
}

.divFirst span {
  font-size: 13px;
  margin: 0 37px;
  color: #999999;
}

.divFirst a {
  font-size: 15px;
  color: #e30000;
}

.divLast {
  margin-top: 13px;
  display: inline-block;
}

.perFirst strong {
  font-size: 15px;
  display: inline-block;
  color: #333333;
}

.perFirst span {
  font-size: 15px;
  color: #767877;
  float: right;
}

.perLast p {
  font-size: 15px;
  color: #666666;

}

.perLast {
  margin-top: 5px;
}

.perLast p span {
  color: #02874a;

}

.divLast p {
  font-size: 15px;
  color: #666666;
}

.personBox {
  background-color: #fff;
  border: 1px solid #dfe6eb;
  border-radius: 5px;
  padding: 7px 0;
}

.saveBtn {
  padding: 70px 0;
  text-align: center;
}

.searchBtn {
  display: inline-block;
  background: #02874a;
  height: 50px !important;
  width: 120px;
  text-align: center;
  float: left;

}

.searchBtn button {
  background: none;
  height: 50px !important;
  line-height: 50px !important;
  border: none;
  color: #fff;
  font-size: 15px;
}

.contentRig h1 {
  font-size: 16px;;
  color: #484848;
  margin: 30px auto 10px auto;

}

.el-form-item span {
  font-size: 15px;
  color: #d67825;
  cursor: pointer;
}

.el-form-item a {
  color: #02874a;
  font-size: 15px;
}

.ewm {
  margin-top: 26px;
}

.ewm img {
  display: block;
  margin: 0 auto;
  width: 197px;
}

.contentLeft {
  width: 258px;
  display: inline-block;
  position: relative;
}

.left2 {
  width: 100%;
  display: inline-block;
  background: #fff;
  padding: 27px 10px 15px 10px;
  border: 1px solid #dfdfdf;
  border-top: 3px solid #027248;
  margin: 16px auto 0 auto;
  position: absolute;
  left: 0;
}

.phHigh {
  color: #027248 !important;
}

.left2 h2 {
  font-size: 18px;

  padding-left: 10px;
  margin-bottom: 7px;
  font-weight: normal;
}

.left2 h2 span {
  margin-right: 15px;
  cursor: pointer;
}

.left2 ul li {
  font-size: 15px;
  color: #111111;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
}

.ulTwo ul li {
  font-size: 15px;
  color: #111111;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;

}

.left1 {
  width: 100%;
  display: inline-block;
  background: #fff;
  padding: 27px 10px 15px 10px;
  border: 1px solid #dfdfdf;
  border-top: 3px solid #027248;
  margin: 0 auto;
  position: relative;
}

.left1 h2 {
  font-size: 18px;
  color: #027248;
  padding-left: 10px;
  margin-bottom: 7px;
  font-weight: normal;
}

.liHigh {
  background: #027248 !important;
  color: #fff !important;
}

.liHigh img {
  display: block !important;
}

.ulTwo {
  position: absolute;
  right: -180px;
  background: #027248;
  top: 0;
  width: 134px;
  opacity: 0.9;
  padding: 18px;
  z-index: 5;
  display: none;

}

.ulTwo p {
  font-size: 15px;
  color: #fff;
  line-height: 24px;
  margin-bottom: 6px;
  position: relative;
}

.left1 ul li {
  font-size: 15px;
  color: #111111;
  padding: 0 16px;
  background: #eaeaea;
  margin-bottom: 6px;
  height: 38px;
  line-height: 38px;
  position: relative;
}

.left1 ul li img {
  float: right;
  display: inline-block;
  vertical-align: middle;
  margin-top: 13px;
  display: none;
}

.left1 ul li:last-child {
  border-bottom: 0;
}

.contentRig {
  width: 870px;
  border: 1px solid #dfe6eb;
  background: #fff;
  border-radius: 5px;
  padding: 0 20px;
}

.rigBox {
  width: 880px;
}

.rigBox2 {
  background: #fff;
  position: absolute;
}

.contentRig dl dt img {
  width: 140px;
  display: block;
  margin: 50px auto 20px auto;
}

.contentRig dl dd p {
  color: #484848;
  font-size: 15px;
  text-align: center;
}

.title {
  padding: 17px 0;
}

.title p {
  font-size: 12px;
  color: #666666;
}

footer {
  height: 84px;
  line-height: 84px;
  background: #4a4e53;
  margin-top: 50px;
  text-align: center;
  position: relative;
}

.imgBottom {
  position: absolute;
  bottom: -54px;
  left: 0;
}

footer p {
  font-size: 14px;
  color: #fff;
}

.el-tabs__item {
  font-size: 20px;
  color: #02874a;
}

.bottomBox {
  width: 1200px;
  margin: 0 auto;
}

.headBottom {
  background: #fff;
  height: 100px;

}

.headSearch {
  height: 40px;
  margin-top: 30px;
  position: relative;
}

.rigBox1 {
  height: 50px;
  margin-bottom: 10px;
  width: 720px;
  margin: 0 auto;
}

.box2 {
  width: 720px;
  margin: 0 auto;
}

.headSearch span {
  background: #02874a;
  position: absolute;
  right: -45px;
  top: 0;
  height: 38px;
  width: 51px;
  border: 1px solid #02874a;
  border-top-right-radius: 5px;
  border-left: 0;
  border-bottom-right-radius: 5px;
}

.headSearch span img {
  margin: 0 auto;
  text-align: center;
  display: block;
  margin-top: 7px;
  height: 24px;
}

.botLeft img {
  width: 489px;
  height: 42px;
  display: block;
  margin-top: 29px;
}

.headUl li {
  font-size: 16px;
  color: #333333;
  display: inline-block;
  float: left;
  margin-right: 40px;
  line-height: 100px;
}

.topBox {
  width: 1200px;
  margin: 0 auto;
}

.headTop {
  background: #f1f1f1;
  height: 30px;
  line-height: 28px;
}

.el-input__inner {
  border: 1px solid #02874a !important;
  font-size: 14px;
}

.headLeft span {
  font-size: 12px;
  color: #666666;
  display: inline-block;
  margin-right: 30px;
}

.headRig span {
  font-size: 12px;
  color: #666666;
  margin-left: 30px;
  display: inline-block;
}
</style>
